import { cn } from '@/lib/utils';

import { LinkButtonSBProps } from '@/components/atoms/linkButton/LinkSB';
import { BlockComponentModel } from '@/components/cms/types/blok-component';
import Breadcrumbs, {
  BreadcrumbsProps,
} from '@/components/molecules/breadcrumbs';
import { StrapiThemes } from '@/components/themeProviderUtils';
import { currentLocaleConfig } from '@/lib/i18n/localeSpecific';

export interface BreadcrumbsSBProps {
  links: LinkButtonSBProps[];
  theme?: StrapiThemes;
}

function getBreadcrumbs(links: LinkButtonSBProps[]): BreadcrumbsProps['items'] {
  const paths = links.map((link) => ({
    href: link.url,
    label: link.text,
  }));

  paths.unshift({
    label: currentLocaleConfig().title,
    href: new URL(currentLocaleConfig().url).origin,
  });

  return paths;
}

export function BreadcrumbsStrapi({
  block,
}: BlockComponentModel<BreadcrumbsSBProps>) {
  const { theme, links } = block;
  const formattedLinks = links ? getBreadcrumbs(links) : [];

  return (
    <div
      className={cn('bg-neutral-N00 px-5 pt-6 md:px-10', theme?.themeKey)}
      data-tracker-section='breadcrumbs'
    >
      <div className={cn('mx-auto my-0 max-w-[1440px]')}>
        <Breadcrumbs {...block} items={formattedLinks} />
      </div>
    </div>
  );
}
